import * as supportMods from '../../app/modules/support/index'
import * as sharedMods from '../../app/modules/shared/index'
import * as supportModels from '../../app/modules/support/models'
import * as sharedModels from '../../app/modules/shared/models'
import bootstrapClient from '../../app/utils/bootstrap-client'

const mods = {
  ...sharedMods,
  ...supportMods
}

const models = {
  ...sharedModels,
  ...supportModels
}

bootstrapClient(mods, models)
